import transactions from './list/sagas'
import wallet from './wallet/sagas'
import transactionTypes from './transactionTypes/sagas'
import cards from './cards/sagas'
import setupIntent from './setupIntent/sagas'
import topup from './topup/sagas'

export default [transactions, wallet, transactionTypes, cards, setupIntent, topup]
